<template>
  <div>
    <v-alert v-model="alert" close-text="Close Alert" v-bind="$attrs">
      <b-row class="justify-content-md-center"
        ><h3 class="err-title">{{ error.errorTitle }}</h3></b-row
      >
      <b-row class="justify-content-md-center"
        ><p class="err-des">
          {{ error.errorDescription }}
        </p>
      </b-row>
    </v-alert>
  </div>
</template>
<style scoped>
.err-title,
.err-des {
  color: #6a63eb;
}
</style>

<script>
export default {
  props: {
    error: {
      errorTitle: {
        type: String,
        required: true
      },
      errorDescription: {
        type: String,
        required: true
      },
      required: true
    }
  },
  data() {
    return {
      alert: true
    };
  }
};
</script>

<style lang="scss" scoped></style>
